import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class StatisticsService extends BaseService{
	constructor() {
		super('/Statistics');
	}

	//public deleteList(list: number[]) {
	//	return this.deleteListWithResourceName(list, 'delete-list')
	//}

	public getAllByFilter(filter: StatisticsFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class StatisticsFilter extends BaseFilter{
	constructor(idTenant?: number | null, periodType?: string | null, periodRange?: string | null, period?: string | null, dateFrom?: string | null, dateTo?: string | null ) {
		super();
	
		this._idTenant = idTenant;
		this._period = period;
		this._periodRange = periodRange;
		this._periodType = periodType;
		this._dateFrom = dateFrom;
		this._dateTo = dateTo;
	}

	private _idTenant?: number | null;
	private _period?: string | null;
	private _periodType?: string | null;
	private _periodRange?: string | null;
	private _dateFrom?: string | null;
	private _dateTo?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._periodType != null ? { PeriodType: this._periodType } : {}),
			(this._periodRange != null ? { PeriodRange: this._periodRange } : {}),
			(this._period != null ? { Period: this._period } : {}),
			(this._dateFrom != null ? { DateFrom: this._dateFrom } : {}),
			(this._dateTo != null ? { DateTo: this._dateTo } : {})

		);
		
		return data;
	};
}